import { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom";
import useApi from "../utilities/useApi";
import { Container, Row, Col, Button, Form, Modal } from "react-bootstrap";
import Loading from "./common/loading";
import enums from "../utilities/enums";
import stringUtilities from "../utilities/stringUtilities";

export default function SkuAddEdit({ isEdit, organisationId }) {
    const { api } = useApi();
    const navigate = useNavigate();
    const { skuId } = useParams();
    const [isLoading, setIsLoading] = useState(false)
    const [newSkuId, setNewSkuId] = useState("")
    const [product, setProduct] = useState("0")
    const skusLandingUrl = `/${ organisationId }/admin-tools/skus`;
    const [canSave, setCanSave] = useState(false);
    const [errorModal, setErrorModal] = useState(null)

    const fetchSku = () => {
        setIsLoading(true)
        api.fetchSkuById(
            skuId,
            data => {
                setNewSkuId(data.id)
                setProduct(String(data.product))
                setIsLoading(false)
            },
            error => console.log(error)
        )
    }

    useEffect(() => {
        if (isEdit) {
            fetchSku()
        }
    }, [])

    const handleSubmit = () => {
        if (isEdit) {
            api.editSku(
                newSkuId, Number(product), 
                () => navigate(skusLandingUrl),
                error => setErrorModal(error.errorMessage)
            )
        } else {
            api.addSku(
                newSkuId, Number(product), 
                data => {
                    if (data.isError) {
                        setErrorModal(data.errorMessage)
                    } else {
                        navigate(skusLandingUrl)
                    }
                },
                error => setErrorModal(error.message)
            )
        }
    }

    useEffect(() => {
        setCanSave(
            !stringUtilities.isNullOrEmpty(newSkuId) &&
            !stringUtilities.isNullOrEmpty(product)
        )
    }, [newSkuId, product])    

    return <>
        {
            isLoading
                ? <Loading />
                : <Container className='pt-5 pb-lg-4 mt-5 mb-sm-2'>
                    <Row>
                        <Col className='mb-5'>
                            <div className='d-flex justify-content-between my-5'>
                                <h1 className="h2 m-0">{ `${ isEdit ? "Edit" : "Add" } SKU` }</h1>
                            </div>
                            <div>
                                <Form.Group className='mb-3 row'>
                                    <Form.Label className='form-label fs-sm col-form-label col-md-3'>
                                        SKU ID
                                    </Form.Label>
                                    <div className="col-md-9 d-flex align-items-center">
                                        <Form.Control readOnly={isEdit} plaintext={isEdit} size='sm' value={ newSkuId } type="text" onChange={ e => setNewSkuId(e.target.value) } />
                                    </div>
                                </Form.Group>

                                <Form.Group className='mb-3 row'>
                                    <Form.Label className='form-label fs-sm col-form-label col-md-3'>
                                        Product
                                    </Form.Label>
                                    <div className="col-md-9 d-flex align-items-center">
                                        <Form.Select size='sm' value={ product } onChange={ e => setProduct(e.target.value) }>
                                            { Object.entries(enums.ProductType).map(([key, value]) => <option key={ key } value={ key } id={ key }>{ value }</option>) }
                                        </Form.Select>
                                    </div>
                                </Form.Group>

                                <Form.Group className='mt-4 row justify-content-end'>
                                    <div className="col-md-9">
                                        <Button onClick={ () => navigate(skusLandingUrl) } variant='outline-primary' size="sm">
                                            Cancel
                                        </Button>
                                        <Button disabled={ !canSave } onClick={ handleSubmit } size='sm' className='ms-2'>
                                            Submit
                                        </Button>
                                    </div>
                                </Form.Group>
                            </div>
                        </Col>
                    </Row>
                    {
                        errorModal &&
                        <Modal show onHide={ () => setErrorModal(null) } centered>
                            <Modal.Header>
                                <Modal.Title>Error</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                { errorModal }
                            </Modal.Body>
                            <Modal.Footer>
                                <Button size="sm" variant='secondary' onClick={ () => setErrorModal(null) }>Close</Button>
                            </Modal.Footer>
                        </Modal>
                    }
                </Container>
        }
    </>
}